import Immutable from 'immutable'
import { createSelector } from 'reselect'

// ------------------------------------
// Constants
// ------------------------------------
export const LOAD_INVOICES = 'inf/invoice/LOAD_INVOICES'
export const RECEIVE_INVOICES = 'inf/invoice/RECEIVE_INVOICES'

export const constants = {
  LOAD_INVOICES,
  RECEIVE_INVOICES,
}

// ------------------------------------
// Actions
// ------------------------------------
export const loadInvoices = invoiceIds => ({
  payload: { invoiceIds },
  type: LOAD_INVOICES,
})
export const receiveInvoices = invoices => ({
  payload: { invoices },
  type: RECEIVE_INVOICES,
})

export const actions = {
  loadInvoices,
  receiveInvoices,
}

// ------------------------------------
// Selectors
// ------------------------------------
export const selectInvoice = createSelector(
  state => state.get('invoices'),
  (state, invoiceId) => invoiceId,
  (invoices, invoiceId) => invoices.find(c => c.get('id') === invoiceId),
)

// ------------------------------------
// Reducer
// ------------------------------------
export const initialState = Immutable.fromJS({
  invoices: Immutable.Set(),
})

function newInvoice(c) {
  return Immutable.fromJS(c)
}

function replaceInvoice(invoices, invoice) {
  return invoices
    .filter(search => search.get('id') !== invoice.get('id'))
    .add(invoice)
}

export default function reducer(state = initialState, action) {
  const { payload } = action

  switch (action.type) {
    case RECEIVE_INVOICES:
      return payload.invoices.reduce((newState, rawInvoice) => newState
          .set('invoices', replaceInvoice(newState.get('invoices'), newInvoice(rawInvoice)))
      , state)

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/redux/modules/invoice.js